// extracted by mini-css-extract-plugin
export default {"category_title":"CategoryTitle_category_title__elLHR","category_title_heading":"CategoryTitle_category_title_heading__cPJI0","explore_btn":"CategoryTitle_explore_btn__a4gF-"};